/**************************************************
 * Nombre:       Dialogo_Canjes
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import Formulario_Retiro from "../Formularios/Formulario_Retiro";
import {obtenerValorEntreagar} from "../../CodNegocio/Funciones/obtenerValorEntreagar";
import {enviarCorreo} from "../../CodNegocio/Retiros/Funciones/enviarCorreo";
import Formulario_Cange from "../Formularios/Formulario_Cange";

const Dialogo_Canjes = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo Datos')

        if (!entidad.id) {
            let doxConst = await obtenerConsecutivo({col: 'consecutivos', id: 'movimientos'})
            entidad.consecutivo = doxConst.data
        }

        entidad.fechaRespuesta = new Date().getTime()
        let dox = await guardarDoc('movimientos', entidad)
        if (dox.res) {
            terminar({aviso: 'Movimiento actualizado con exito'})
            await enviarCorreo({
                correo: entidad.correo,
                billetera: entidad.billetera,
                hash: entidad.hashTransaccion,
                valor: obtenerValorEntreagar({valor: entidad.valor, tipo: entidad.metodo},)
            })
        } else {
            terminar({aviso: 'Algo inesperado paso, intentalo nuevamente', variante: 'error'})
        }

    }


    const borrar = async () => {
        await borrarDoc('movimientos', datos.id)
        terminar({aviso: 'Movimiento borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Cange props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Canjes